import { FC } from "react";
import ColumnSwitches from "./options/columnSwitches/ColumnSwitches";
import DataDateRangePicker from "./options/datePicker/dataDateRangePicker";
import { ExportButton } from "./options/export/ExportButton";
import Views from "./options/views/Views";
import DataTableColumns from "../columnsAndActions/ColumnsAndActions";
import { useDispatch, useSelector } from "react-redux";
import {
  selectDataTableUnifiedState,
  selectExportDataState,
} from "../../../../redux/selectors/unifiedSelectors";
import {
  setDateRangePicker,
  setOpenDateRangePicker,
} from "../../../../redux/slices/dataTable/dataTableFilters";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  dataTableActionNewFilter,
} from "../../../../redux/actions/dataTable/DataTableAsyncActions";

import {
  setFilterModel,
  setPreselectedFilterField,
  setShowFilterForm,
} from "../../../../redux/slices/dataTable/data";

import { useTranslation } from "react-i18next";
import { CustomFilterBar } from "../customFilterForm/CustomFilterButton";
export type MenuOptionsProps = {
  isViewerOnly: boolean;
  loadings: boolean;
};

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    openRangeDate: () => dispatch(setOpenDateRangePicker(true)),
    closeRangeDate: () => dispatch(setOpenDateRangePicker(false)),

    setFiltersDataTableActions: () => {
      dispatch(dataTableActionNewFilter());
    },

    setActivityDate: (date: Date[]) => {
      dispatch(setDateRangePicker(date));
    },

    setFilterModel: (filterModel: any) => {
      dispatch(setFilterModel(filterModel));
    },

    setShowFilterForm: (show: boolean) => {
      dispatch(setShowFilterForm(show));
    },

    setPreselectedFilterField: (field: string | null) => {
      dispatch(setPreselectedFilterField(field));
    },

    applyFilters: () => {
      dispatch(dataTableActionNewFilter());
    },
  };
};

const MenuOptions: FC<MenuOptionsProps> = ({ isViewerOnly, loadings }) => {
  const [t] = useTranslation("global");
  const { columnsDataTable, actionsDataTable } = DataTableColumns();

  const { loading, filters, tableOptions, showFilterForm, filterModel } =
    useSelector(selectDataTableUnifiedState);
  const { loadingExport } = useSelector(selectExportDataState);

  const isDisabled = columnsDataTable.length === 0 || loading;
  const {
    setActivityDate,
    openRangeDate,
    closeRangeDate,
    setFiltersDataTableActions,
    setFilterModel,
    setShowFilterForm,
    setPreselectedFilterField,
    applyFilters,
  } = SetActions();

  const {
    selectDataDateActivity,
    filtersSelectedLength,
    loadingFilters,
    selectDateRangePickerOpen,
    preselectedField,
  } = filters;

  const loadingsValues = loading || loadingExport || loadingFilters;

  const hasNoData = actionsDataTable.length === 0;

  const handleApplyFilters = () => {
    applyFilters();
  };

  return (
    <div className="panel-options">
      <div className="options-left-data-panel">
        <div className="data-date-range-picker">
          <DataDateRangePicker
            setActivityDate={setActivityDate}
            selectDataDateActivity={selectDataDateActivity}
            openRangeDate={openRangeDate}
            closeRangeDate={closeRangeDate}
            callTheFetchData={setFiltersDataTableActions}
            open={selectDateRangePickerOpen}
            //optional
            filtersSelectedLength={filtersSelectedLength}
            loading={loadingsValues}
            actionsDataTable={actionsDataTable}
            columnsDataTable={columnsDataTable}
            tableOptions={tableOptions}
          />
        </div>
        <div className="data-extra-filters">
          <CustomFilterBar
            t={t}
            hasNoData={hasNoData}
            isDisabled={isDisabled}
            loadingsValues={loadingsValues}
            filterModel={filterModel}
            setShowFilterForm={setShowFilterForm}
            showFilterForm={showFilterForm}
            setPreselectedFilterField={setPreselectedFilterField}
            preselectedField={preselectedField}
            columnsDataTable={columnsDataTable}
            setFilterModel={setFilterModel}
            handleApplyFilters={handleApplyFilters}
          />
        </div>
        <div className="data-extra-filters">
          <ColumnSwitches loading={loadings} disabled={isDisabled} />
        </div>
        <div className="data-extra-filters">
          <Views loading={loadings} disabled={isDisabled} />
        </div>
      </div>
      <div className="options-right-data-panel">
        <div>
          {!isViewerOnly && (
            <ExportButton loading={loadings} disabled={isDisabled} />
          )}
        </div>
      </div>
    </div>
  );
};

export default MenuOptions;
